<template>
  <event-card
    class="my-3"
    :title="entry.payload_type_description"
    :icon="getEventIcon(entry.origin_id)"
    :color="getEventColor(entry.origin_id)"
    :date="entry.entry_datetime"
    :children="entry.entries"
    :icon-tooltip="entry.origin_description"
    :resume="entry.resume"
    :subtitle="
      entry.origin_id === COM_P1_ORIGIN_ID ? entry.payload.ptm_typ : null
    "
    :subsubtitle="
      entry.origin_id === COM_P1_ORIGIN_ID ? entry.payload.ptm_lib : null
    "
    :author="`${entry.author_name} (${entry.author_type})`"
  >
    <template v-slot:actions>
      <slot />
      <documents-menu
        :propertyId="entry.property_id"
        :actionId="Number(entry.external_id)"
        :document-exists="entry.document_exists"
      />
      <component :is="btn" v-bind="btnProps" />
    </template>
  </event-card>
</template>

<script>
import EventCard from '@/components/cards/EventCard';
import { getEventColor, getEventIcon } from '@/business/utils/display';
import LinkToActionplan from '@/components/tools/LinkToActionplan';
import LinkToAction from '@/components/tools/LinkToAction';
import LinkToRequest from '@/components/tools/LinkToRequest';
import { generateMessage } from '@/utils/i18n';
import DisplayIconBadgeTooltip from '@/components/displays/DisplayIconBadgeTooltip';
import DocumentsMenu from '@/pages/actions/DocumentsMenu';
import {
  ACTION_PAYLOAD_TYPE_ID,
  ACTIONPLAN_PAYLOAD_TYPE_ID,
  COM_P1_ORIGIN_ID,
  REQUEST_PAYLOAD_TYPE_ID,
} from '@/store/modules/logbook/payloadTypes/constants';

export default {
  name: 'EntryCard',
  components: {
    DisplayIconBadgeTooltip,
    EventCard,
    LinkToActionplan,
    LinkToAction,
    LinkToRequest,
    DocumentsMenu,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  data: () => ({ btnProps: null, btn: null, COM_P1_ORIGIN_ID }),
  watch: {
    entry: {
      immediate: true,
      deep: true,
      handler(entry) {
        if (entry.external_id) {
          if (entry.payload_type_id === ACTIONPLAN_PAYLOAD_TYPE_ID) {
            this.btn = 'LinkToActionplan';
            this.btnProps = {
              actionPlanId: entry.external_id,
            };
          } else if (entry.payload_type_id === ACTION_PAYLOAD_TYPE_ID) {
            this.btn = 'LinkToAction';
            this.btnProps = {
              actionplanId: entry.payload.actionplan_id,
              actionId: Number(entry.external_id),
            };
          } else if (entry.origin_id === REQUEST_PAYLOAD_TYPE_ID) {
            this.btn = 'LinkToRequest';
            this.btnProps = {
              requestId: Number(entry.external_id),
              propertyId: entry.property_id,
            };
          }
        }
      },
    },
  },
  methods: {
    generateMessage,
    getEventIcon,
    getEventColor,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
